import React from 'react';


type ToastRootProps = {
  onClose?: () => void;
  children: React.ReactNode;
};
const ToastRoot = ({ onClose, children }: ToastRootProps) => {
  return (
    <div
      role="status"
      className="relative mb-2 w-80 sm:w-96 overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/10 text-gray-900"
    >
      {/* Close button (keeps the same onClose API) */}
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute right-2 top-2 inline-flex h-8 w-8 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
        >
          ×
        </button>
      )}
      {children}
    </div>
  );
};

const ToastHeader = ({ children }: { children: React.ReactNode }) => (
  <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2 text-sm">
    {children}
  </div>
);

const ToastBody = ({ children }: { children: React.ReactNode }) => (
  <div className="px-4 py-3 text-sm">{children}</div>
);

// Preserve original JSX syntax. Drop-in replacement for react-bootstrap/Toast
const Toast = Object.assign(ToastRoot, { Header: ToastHeader, Body: ToastBody });
export default Toast
